import type { TenantConfig } from '@/types/TenantConfig'

export const oscars: TenantConfig = {
  logo: 'assets/oscars/static/logo.png',
  teaserImageSize: {
    width: 360,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/oscars/static/complete.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/oscars/static/fonts.css',
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Checkout',
      },
    },
  },
}
